import { createAsyncAction, createAction } from 'typesafe-actions';
import { ReviewsResponse, Review } from './types';
import { Token } from '../users/types'
import { authFetch, unauthFetch } from '../../utils';

export const updateApiError = createAction('questions/UPDATE_API_ERROR', resolve =>
  (apiError: string) => resolve(apiError)
);

export const getReviewsActions = createAsyncAction(
  'reviews/FETCH_REQUEST',
  'reviews/FETCH_SUCCESS',
  'reviews/FETCH_FAILURE'
)<void, ReviewsResponse, Error>();

export const getReviews = (parkCode: string, nextKey?: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(getReviewsActions.request());
      const key = nextKey ? `?nextkey=${nextKey}` : '';
      const result: any = await unauthFetch(`reviews/parks/${parkCode}${key}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      });
      if (result.status === 404) {
        dispatch(getReviewsActions.failure(new Error('Not found.')));
        return;
      }
      const res = await result.json();
      dispatch(getReviewsActions.success({ ...res, hasNextKey: !!nextKey  }));
    });
  };
};

export const addReviewAction = createAsyncAction(
  'reviews/ADD_REVIEW_REQUEST',
  'reviews/ADD_REVIEW_SUCCESS',
  'reviews/ADD_REVIEW_FAILURE'
)<void, Review[], Error>();

export const addReview = (tokens: Token, parkCode: string, review: string, stars: number) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(addReviewAction.request());
      const result: any = await authFetch(tokens, {
        url: `reviews/parks/${parkCode}`,
        param: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            review,
            stars,
            park_code: parkCode,
          }),
        },
      });
      if (result.error) {
        dispatch(addReviewAction.failure(new Error(result.error)));
        return;
      }
      const res = await result.json();
      if (result && result.status !== 201) {
        dispatch(addReviewAction.failure(new Error(res.error.description || res.error.message)));
        return;
      }
      dispatch(addReviewAction.success(res));
    });
  };
};
